/* eslint-disable @typescript-eslint/ban-types */
import { isMeasurement } from '../enums/MetricIds';
/** Operations */
/** Check if a value is greater, lower, or equal to a threshold */
export const lookupOperations = ['lt', 'gt', 'eq'];
/** Check if a sum is greater than a threshold */
export const cumulOperations = [`cumul-gt`];
/** Operations that can be made on measures */
export const measureOperations = [...lookupOperations, ...cumulOperations];
/** List of available infection levels */
export const alertCompatibleAppleScabLevels = ['light', 'medium', 'severe'];
/** Order of both keys and operations matters for UI */
export const operationsPerWeatherSource = {
    RR: [
        // Starts or stops raining/tavmills
        'change',
        // Sum
        'cumul-gt',
        // Forecasts
        'near-gt',
        // Intensity on a sliding interval
        'sliding-cumul-gt'
    ],
    T: ['lt', 'gt'],
    U: ['lt', 'gt'],
    FF: ['lt', 'gt'],
    FXY: ['lt', 'gt'],
    T_WET: ['lt', 'gt'],
    T_DRY: ['lt', 'gt'],
    LW_V: ['lt', 'gt', 'change'],
    LW_D: ['cumul-gt'],
    T_SOIL: ['lt', 'gt'],
    T_CAPA: ['lt', 'gt'],
    ECP: ['lt', 'gt'],
    SWC: ['lt', 'gt']
    // DD: ['change']
};
export const operationsPerDssSource = {
    GDD: ['cumul-gt'],
    IRRI_TENSIO: ['eq'],
    IRRI_CAPA: ['eq'],
    TAVMILLS: ['eq', 'change']
};
export const availableOperationPerSource = {
    ...operationsPerWeatherSource,
    ...operationsPerDssSource
};
export const plotsOnlySources = ['IRRI_CAPA', 'IRRI_TENSIO', 'TAVMILLS', 'ECP', 'SWC'];
export const isWeatherSource = (src) => {
    return src in operationsPerWeatherSource;
};
export const isDssSource = (src) => {
    return src in operationsPerDssSource;
};
export const sourceToMetric = (source) => {
    let result;
    if (source === 'IRRI_TENSIO') {
        result = 'HPOT';
    }
    else if (source === 'IRRI_CAPA') {
        result = 'CAPA';
    }
    else if (source === 'GDD') {
        result = 'T';
    }
    else if (source === 'TAVMILLS') {
        result = 'LW_D';
    }
    else {
        result = source;
    }
    return result;
};
/** Typed object keys */
const keysOf = (x) => Object.keys(x);
export const isForecasted = (params) => {
    return 'amountInHours' in params;
};
export const isThresholded = (params) => {
    return 'threshold' in params;
};
export const isDSSPredicate = (predicate) => {
    return (keysOf(operationsPerDssSource).includes(predicate.source) ||
        predicate.source === 'ECP' ||
        predicate.source === 'SWC');
};
export const isForecastPredicate = (predicate) => {
    return isForecasted(predicate.params);
};
export const isMeasurementPredicate = (predicate) => {
    return (isMeasurement(sourceToMetric(predicate.source)) &&
        !isDSSPredicate(predicate) &&
        !isForecasted(predicate.params));
};
export const allWeatherSources = keysOf(operationsPerWeatherSource);
export const allDssSources = keysOf(operationsPerDssSource);
export const getPredicateKey = (predicate) => `${predicate.op}-${predicate.source}`;
export const isWaterStatusThresholded = (params) => {
    return 'thresholds' in params;
};
export const isAppleScabParams = (params) => {
    return 'infectionLevels' in params;
};
export const isCumul = (params) => {
    return isThresholded(params) && 'since' in params;
};
export const isBased = (params) => {
    return 'base' in params;
};
export const isWaterStatusThresholdParams = (params) => {
    return 'horizons' in params && 'thresholds' in params;
};
export const isLookupOp = (val) => {
    return lookupOperations.includes(val);
};
export const targetKinds = ['plots', 'devices', 'stations'];
export const isTargetsWithTZ = (val) => {
    return ((val.plots.length > 0 && typeof val.plots[0] !== 'number') ||
        (val.devices.length > 0 && typeof val.devices[0] !== 'number') ||
        (val.stations.length > 0 && typeof val.stations[0] !== 'number'));
};
